import { Alert, Button, Divider } from '$HVUI';
import { storeEvent } from '$Utils';

export const RegistrationBlock = ({
    isVaccine,
    resetURL,
    token,
    visit: { can_upload_vaccinations }
}) => {
    const showRegistration = typeof resetURL !== 'undefined' && resetURL !== '';
    if (!showRegistration) return '';

    const registrationMessage = () => {
        if (isVaccine) {
            if (can_upload_vaccinations) {
                return 'Have you already received your 2nd dose? Complete your digital vaccination record with Healthvana by uploading an image of your CDC card after creating an account.';
            }

            return 'To maintain secure access to your vaccination record(s), please create a Healthvana account:';
        }
        return 'To download a PDF record of your result(s) and maintain secure access to them, please create a Healthvana account:';
    };

    return (
        <>
            {!isVaccine && <Divider />}
            <Alert
                style={{ marginBottom: '1.5em' }}
                message={
                    <>
                        {registrationMessage()}
                        <Button
                            onClick={async () => {
                                await storeEvent('token_create_account', {
                                    token
                                });
                                window.location.assign(resetURL);
                            }}
                            style={{
                                display: 'block',
                                margin: '16px auto auto auto'
                            }}
                            id="createAccount"
                            level="primary"
                            size="narrow"
                            text="Create Account"
                        />
                    </>
                }
                type="info"
            />
        </>
    );
};
